import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import BuyOrderStatusBar, { BuyOrderStatusBarNew, CreateStatusBarProps } from '../../../BuyOrderStatusBar'
import BuyOrderCreateNoPermissionButtons, { BuyOrderCreateNoPermissionButtonsNew } from '../BuyOrderCreateNoPermissionButtons'

type BuyOrderCreateNoPermissionStepHeaderProps = & CreateStatusBarProps & OrderStepButtonsBaseComponentProps

const BuyOrderCreateNoPermissionStepHeaderDecider: React.FC<BuyOrderCreateNoPermissionStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={BuyOrderCreateNoPermissionStepHeaderDefault} NewComponent={BuyOrderCreateNoPermissionStepHeaderNew} {...rest} />
    )
}

const BuyOrderCreateNoPermissionStepHeaderDefault: React.FC<BuyOrderCreateNoPermissionStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <BuyOrderStatusBar {...rest} />
            <BuyOrderCreateNoPermissionButtons {...rest} />
        </div>
    )
}

const BuyOrderCreateNoPermissionStepHeaderNew: React.FC<BuyOrderCreateNoPermissionStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <BuyOrderStatusBarNew {...rest} />
            <BuyOrderCreateNoPermissionButtonsNew {...rest} />
        </Fragment>
    )
}

export default BuyOrderCreateNoPermissionStepHeaderDecider